import { createSafeContext } from '@/util/context';

import type { ShortcutContextValue } from '../type';

const ShortcutContext =
  createSafeContext<
    ShortcutContextValue<Dictionary<string>, Dictionary<string>>
  >();

export default ShortcutContext;
